// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"e2eee8db","453":"f47b74c5","844":"293fa1c8"}[chunkId] + ".chunk.js";
};